// Simple in-memory cache for student counts per school
class StudentCountCache {
    constructor() {
        this.cache = new Map();
        this.cacheTimeout = 30 * 60 * 1000; // 30 minutes - longer cache for student counts
        this.lastFetch = 0;
        this.isLoading = false;
    }

    async getStudentCounts() {
        // Check if we have recent data
        if (this.cache.size > 0 && Date.now() - this.lastFetch < this.cacheTimeout) {
            return Array.from(this.cache.values());
        }

        // Prevent multiple simultaneous requests
        if (this.isLoading) {
            return Array.from(this.cache.values());
        }

        this.isLoading = true;
        try {
            const response = await fetch('/api/students/school-counts');
            if (response.ok) {
                const data = await response.json();
                const schoolCounts = data.schoolCounts || [];

                // Update cache
                this.cache.clear();
                schoolCounts.forEach(item => {
                    this.cache.set(item.schoolId, item);
                });

                this.lastFetch = Date.now();
                return schoolCounts;
            } else {
                console.warn('Failed to fetch student counts, using cached data');
                return Array.from(this.cache.values());
            }
        } catch (error) {
            console.error('Error fetching student counts:', error);
            return Array.from(this.cache.values());
        } finally {
            this.isLoading = false;
        }
    }

    getStudentCount(schoolId) {
        const cached = this.cache.get(schoolId);
        return cached ? cached.studentCount : 0;
    }

    clear() {
        this.cache.clear();
        this.lastFetch = 0;
    }

    // Refresh cache
    async refresh() {
        this.lastFetch = 0;
        return await this.getStudentCounts();
    }
}

// Create a singleton instance
const studentCountCache = new StudentCountCache();

export default studentCountCache;
